module.exports = __webpack_public_path__ + "img/11.40b6b81b.jpg";